import {RouteEntry} from "../../shared/routes";
import {Report} from "./Report";
import {TrackMyClaim} from "../track/TrackMyClaim";

export const reportRoutes: Array<RouteEntry> = [
    { path: '/report/:id', component: Report },
    { path: '/report/', component: TrackMyClaim },
];
